var map = {
	"./disgust1.jpg": "480a",
	"./disgust2.jpg": "af8c",
	"./disgust3.jpg": "4571",
	"./disgust4.jpg": "03bb",
	"./fear1.jpg": "63da",
	"./fear2.jpg": "fb82",
	"./fear3.jpg": "3676",
	"./fear4.jpg": "02b9",
	"./interest1.jpg": "456a",
	"./interest2.jpg": "77ec",
	"./interest3.jpg": "d91b",
	"./interest4.jpg": "daca",
	"./joy1.jpg": "63f8",
	"./joy2.jpg": "0250",
	"./joy3.jpg": "4d75",
	"./joy4.jpg": "8305",
	"./neutral.jpg": "d81e",
	"./sadness1.jpg": "70cb",
	"./sadness2.jpg": "c6ae",
	"./sadness3.jpg": "5e1b",
	"./sadness4.jpg": "dede",
	"./surprize1.jpg": "a54b",
	"./surprize2.jpg": "5655",
	"./surprize3.jpg": "fad7",
	"./surprize4.jpg": "0125",
	"./trust1.jpg": "ee52",
	"./trust2.jpg": "b7f8",
	"./trust3.jpg": "3dec",
	"./trust4.jpg": "ade4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dd97";